export default __webpack_public_path__ + "static/media/homeVideo.9267a411.mp4";